import React, { Component } from "react";
import { Container, Form, Row, Col, Button, Modal } from "react-bootstrap";
import { submitFormData } from "../utilities/formUtilities";

class MarketingModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideModalFormClass: "show",
      displaySuccessSubmitClass: "hide",
      displayErrorSubmitClass: "hide",
    };
    this.submitForm = this.submitForm.bind(this);
    this.successfulSubmitForm = this.successfulSubmitForm.bind(this);
    this.resetAndHideModal = this.resetAndHideModal.bind(this);
    this.resetModal = this.resetModal.bind(this);
    this.errorSubmitForm = this.errorSubmitForm.bind(this);
  }

  submitForm = (e) => {
    e.preventDefault();
    // console.log("submitting form");

    let firstName = e.target.elements.firstName.value;
    let lastName = e.target.elements.lastName.value;
    let natureOfInquiry = e.target.elements.natureOfInquiry.value;
    let email = e.target.elements.email.value;
    let companyName = e.target.elements.companyName.value;


    let submitData = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      companyName: companyName,
      natureOfInquiry: natureOfInquiry,
    };

    // console.log(submitData);

    /*
    https://formcarry.com/s/RsLXP8gyF9pT
    bld_ai_events_marketing@bld.ai
    */

    submitFormData(
      "https://formcarry.com/s/RsLXP8gyF9pT",
      submitData,
      this.successfulSubmitForm,
      this.errorSubmitForm,
      this.errorSubmitForm
    );
  }

  successfulSubmitForm = () => {
    this.setState({ 
      hideModalFormClass: "hide",
      displaySuccessSubmitClass: "show",
      displayErrorSubmitClass: "hide",
    });
  }

  errorSubmitForm = () => {
    this.setState({ 
      hideModalFormClass: "hide",
      displaySuccessSubmitClass: "hide",
      displayErrorSubmitClass: "show",
    });
  }

  resetModal = () => {
    let marketingForm = document.getElementById("marketingForm");

    marketingForm.reset();
    this.setState({ 
      hideModalFormClass: "show",
      displaySuccessSubmitClass: "hide",
      displayErrorSubmitClass: "hide",
    });
  }

  resetAndHideModal = () => {
    this.resetModal();
    this.props.closeModal();
  }

  render() {
    return(
      <Modal show={this.props.modalOpen} onHide={this.resetAndHideModal} centered>
        <Modal.Header className="header-center" closeButton>
          <span className="modal-header-text">
            Contact Marketing
          </span>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <p className="text-center mb-5">Let’s do big things together. Get in touch with us to discuss press opportunities, advertisements, content or other related marketing opportunities. </p>
            <section className={"contact contactFormContainer " + this.state.hideModalFormClass}>
              <form acceptCharset="UTF-8" className="contact-form ajax" onSubmit={this.submitForm} id="marketingForm">
                <Row>
                  <Col sm="12">
                    <Form.Group>
                      <Form.Label>First name<span className="required">*</span></Form.Label>
                      <Form.Control required type="text" name="firstName" />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Form.Group>
                      <Form.Label>Last name<span className="required">*</span></Form.Label>
                      <Form.Control required type="text" name="lastName" />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Form.Group>
                      <Form.Label>Company Name<span className="required">*</span></Form.Label>
                      <Form.Control required type="text" name="companyName" />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Form.Group>
                      <Form.Label>Email<span className="required">*</span></Form.Label>
                      <Form.Control required type="email" name="email" />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Form.Group>
                      <Form.Label> What is the nature of your inquiry to bld.ai marketing<span className="required">*</span></Form.Label>
                      <Form.Control required type="text" name="natureOfInquiry" />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <input type="hidden" name="_gotcha" />
                    <Button className="btn-submit hs-button" type="submit">Submit</Button>
                    <Button className="hs-button ml-2 btn-secondary" onClick={this.resetAndHideModal}>Close</Button>
                  </Col>
                </Row>
              </form>
            </section>
            <section className={"contact contactFormContainer confirmationMessage " + this.state.displaySuccessSubmitClass}>
              <p>Form submitted successfully</p>
              <Button className="btn-submit hs-button" onClick={this.resetModal}>
                Send another marketing query
              </Button>
            </section>
            <section className={"contact contactFormContainer confirmationMessage " + this.state.displayErrorSubmitClass}>
              <p>There was an error with the submission. Please try again</p>
              <Button className="btn-submit hs-button" onClick={this.resetModal}>
                Send another marketing query
              </Button>
            </section>
          </Container>
        </Modal.Body>
      </Modal>
    );
  }
}

export default (MarketingModal);